<template>
  <nav>
    <!--Non-Mobile Only-->
    <b-nav class="hidden-sm-down">
      <b-nav-item to="/" exact><div class="icon icon-home"></div></b-nav-item>
      <li class="divider-vertical"></li>
      <editorial-board-dropdown></editorial-board-dropdown>
      <li class="divider-vertical"></li>
      <publications-dropdown></publications-dropdown>
      <li class="divider-vertical"></li>
      <b-nav-item to="/for-authors/submission-guidelines" exact>For Authors</b-nav-item>
      <li class="divider-vertical"></li>
      <about-dropdown></about-dropdown>
      <div class="col d-flex justify-content-center ml-auto hidden-lg-down">
        <search-field></search-field>
      </div>

      <div class="search-dropdown col">
        <div class="button-wrapper">
          <b-btn v-b-toggle.search_collapse class="button-secondary">
            <div class="icon icon-search"></div>
          </b-btn>
        </div>
      </div>
      <button id="submit_btn" class="button-primary">Submit Paper</button>
      <b-collapse is-nav id="search_collapse" class="nav flex-column">
        <search-field></search-field>
      </b-collapse>

    </b-nav>
    <!--Non-Mobile Only-->

    <!--Mobile Only-->
    <b-navbar class="hidden-md-up" toggleable id="navbar">
      <b-nav class="horizontal-nav">
        <b-nav-item :to="{ name: 'editorialBoardMembers' }" class="col">Editorial Board</b-nav-item>
        <b-nav-item :to="{ name: 'issueDetail', params: { volumeId: 1, issueId: 1 }}" class="col">Current Issue</b-nav-item>
        <b-nav-item :to="{ name: 'forAuthorsSubmissionGuidelines' }" class="col">For Authors</b-nav-item>
        <b-nav-item :to="{ name: 'contact' }" class="col">Contact</b-nav-item>
        <b-nav-item class="col-auto"><b-nav-toggle class="mx-0 p-0" position="static"  target="nav_collapse"></b-nav-toggle></b-nav-item>
      </b-nav>
      <b-collapse is-nav id="nav_collapse" class="nav flex-column">
        <b-nav-item to="#">
          <search-field></search-field>
        </b-nav-item>
        <editorial-board-dropdown class="mobile"></editorial-board-dropdown>
        <publications-dropdown class="mobile"></publications-dropdown>
        <b-nav-item class="mobile" to="/for-authors/submission-guidelines" exact>For Authors</b-nav-item>
        <about-dropdown class="mobile"></about-dropdown>
      </b-collapse>
    </b-navbar>
    <!--Mobile Only-->
  </nav>

</template>

<script>
  import EditorialBoardDropdown from '@/components/main-layout/header-nav/dropdowns/EditorialBoardDropdownComponent'
  import PublicationsDropdown from '@/components/main-layout/header-nav/dropdowns/PublicationsDropdownComponent'
  import AboutDropdown from '@/components/main-layout/header-nav/dropdowns/AboutDropdownComponent'
  import ForAuthorsDropdown from '@/components/main-layout/header-nav/dropdowns/ForAuthorsDropdownComponent'
  import SearchField from '@/components/main-layout/header-nav/SearchFieldComponent'

  export default {
    components: {
      EditorialBoardDropdown,
      PublicationsDropdown,
      AboutDropdown,
      ForAuthorsDropdown,
      SearchField
    },
    name: 'header-nav'
  }
</script>

// @formatter:off
<style lang="scss">
  #search_collapse {
    position: absolute;
    top: 45px;
    right: 20px;
    background: white;
    padding: 10px;
  }
  .search-dropdown {
    text-align: right;
    .btn {
      background-color: $secondary-color;
      width: 28px;
      height: 28px;
      padding: 0;
    }
  }
  .search-dropdown, #search_collapse {
    @media (min-width: $breakpoint-xl) {
      display: none;
    }
  }
  .nav-wrapper #submit_btn {
    display: none;
  }
  .nav-wrapper.fixed #submit_btn {
    display: block;
    margin-right: 15px;
  }
  .nav-wrapper.fixed {
    nav .nav .nav-item .nav-link {
      @media (max-width: ($breakpoint-lg - 1px)) {
        padding: 0 12px;
      }
    }
  }

  nav {
    padding: 10px 0;
    .nav {
      z-index: 5;
      align-items: center;
      .nav-item {
        flex-direction: column;
        justify-content: center;
        display: flex;

        &.dropdown {
          &.show {
            .dropdown-toggle:after {
              border-top: none;
              border-bottom: 0.3em solid;
            }
          }

          .dropdown-menu {
            border: none;
            width: 100%;
            padding: 10px 20px;

            .dropdown-item {
              white-space: normal;
              color: $secondary-color;
              border-top: 1px solid $navbar-dropdown-separator;
              text-align: center;
              padding: 15px 0;
              line-height: 1.25em;
              font-weight: 100;

              &:hover {
               color: darken($secondary-color, 15%);
               background-color: transparent;
              }

              &.active {
                background-color: transparent;
                color: $primary-color;
              }

              &:focus {
                outline: none;
              }
            }
          }
        }

        .nav-link {
          display: flex;
          align-items: center;
          text-align: center;
        }

        .nav-link, .open > .nav-link, .nav-link.open {
          padding: 0 28px;
          line-height: 1.25em;
        }

        .active > .nav-link, .nav-link.active {
          color: $primary-color;
        }
      }
    }
  }

  @media (max-width: ($breakpoint-md - 1px)) {
    .search-form{
      border-bottom: 1px solid $secondary-color;
    }
    .navbar-toggler-static {
      width: 30px;
      padding: 0px;
      &:focus {
         outline: none;
       }
      .navbar-toggler-icon {
        width: 20px;
      }
    }
    nav {
         padding: 0px;
        .nav {
          align-items: stretch;
        }
        .navbar {
          padding: 0px;
          .horizontal-nav {
            border-bottom: 1px solid $light-bg;
            a.nav-link {
              justify-content: center;
              display: flex;
              flex-direction: column;
            }
          }
          .nav-item {
          background-color: $white;
          border-right: 1px solid $light-bg;
          opacity: 0.9;
          padding: 0px;

          a.nav-link {
            text-align: center;
            padding: 0px 4px;
            min-height: 50px;
            border: none;
            border-right-width: 0px !important;
          }
          &.mobile {
            .nav-link{
              text-align: start;
              min-height: 30px;
              padding: 10px 0px;
              margin: 0px 20px;
              text-decoration: none;
              border-bottom: 1px solid $grey-border;
              border-right-width: 0px;
            }
            .dropdown-menu {
              position: static;
              border: none;
              float: none;
              padding-top: 0px;
              margin-top: 0px;
              width: inherit;
              .dropdown-item {
                width: inherit;
                padding: 10px 20px;
                margin: 0px 20px;
                background-color: $link-button-bg;
                border-bottom: 1px solid $white;
                border-right-width: 0px;
                outline: none;
                text-align: left;
              &.active{
                 background-color: $link-button-bg;
                 color: $secondary-color;
                 text-decoration: none;
               }
              }
            }
          }
        }
      }
    }
  }

</style>
// @formatter:on



// WEBPACK FOOTER //
// HeaderNavComponent.vue?6e79b6e0